import endpoints from 'api/endpoints';
import { api } from 'api/rest';

export class PlayerStatisticsService {
  static search(query: string) {
    return api.get(endpoints.playerStatsSearch, { params: { q: query } });
  }

  static getById(id: string) {
    return api.get(`${endpoints.playerStats}/${id}`);
  }
}
